<template>
<!-- 财务管理 明细 -->
    <content-view>
        <div slot="header">
            <a-tabs defaultActiveKey="4" @change="callback1" class="tradeRecord_tab">
                <a-tab-pane tab="现金" key="4" forceRender></a-tab-pane>
                <a-tab-pane tab="POS机" key="3"></a-tab-pane>
                <a-tab-pane tab="扫码枪" key="11"></a-tab-pane>
                <a-tab-pane tab="储值" key="6"></a-tab-pane>
                <a-tab-pane tab="后台操作" key="0"></a-tab-pane>
                <a-tab-pane tab="退款记录" key="99"></a-tab-pane>
                <a-tab-pane tab="销售一览" key="-1"></a-tab-pane>
<!--                <a-tab-pane tab="手工交账" key="999"></a-tab-pane>-->
            </a-tabs>
        </div>
        <div class="trade-record">
            <p class="trade-record_title mb8">
                <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>
                日期：{{$route.query.date}}；
                <template v-if="!Boolean(shopName)">
                    收银员：{{$route.query.cashier}}
                </template>
                <template v-else>
                    门店：{{shopName}}
                </template>
            </p>
            <!-- 销售一览 -->
            <div v-show="type == -1">
                <a-table
                    bordered
                    :dataSource="dataSourceAll"
                    :columns="columnsAll"
                    :scroll="{ x: 1000,  y: 440 }"
                    :pagination="false"
                    :rowKey="(record,index) => index"
                    :loading="tableLoading"
                >
                    <span slot="showName" slot-scope="showName">{{Boolean(showName) ? showName : '-'}}</span>
                    <span slot="ticketName" slot-scope="ticketName">{{ticketName || '-'}}</span>
                </a-table>
            </div>
            <!-- 退款 -->
            <div v-show="type == 99">
                <a-table
                    bordered
                    :dataSource="dataSourceRefund"
                    :columns="refundColumns"
                    :scroll="{ x: 1500,  y: 440 }"
                    :pagination="false"
                    :rowKey="(record,index) => index"
                    :loading="tableLoading"
                >
                    <span slot="none" slot-scope="detail">{{detail || '-'}}</span>
                    <span slot="isManualPayment" slot-scope="a, row">{{row.isManualPayment ? '是' : "否"}}</span>
                    <span slot="payMode" slot-scope="a,row">{{$utils.payMode[row.payMode] || "-"}}</span>
                </a-table>
            </div>
            <!-- 手工交账 -->
            <div v-show="type == 999">
                <a-table
                    bordered
                    :dataSource="financeManualDetailData"
                    :columns="financeManualDetailColumns"
                    :scroll="{ x: 1000,  y: 440 }"
                    :pagination="false"
                    :rowKey="(record,index) => index"
                    :loading="tableLoading"
                >
                    <template slot="isEmpty" slot-scope="key">
                        {{key | isEmpty}}
                    </template>
                    <template slot="myToFixed2" slot-scope="key">
                        {{key | myToFixed2}}
                    </template>
                </a-table>
            </div>
            <!-- 现金、POS机、储值、后台操作 -->
            <div v-show="type == 0 || type == 3 || type == 4 || type == 6">
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :scroll="{ x: 1400, y: 440 }"
                    :pagination="pagination"
                    :rowKey="(record,index) => index"
                    style="word-break:break-all;"
                    :loading="tableLoading"
                    @change="changePage"
                >
                    <span slot="happenTime" slot-scope="happenTime">{{happenTime ? happenTime.replace('T',' ') : "-"}}</span>
                    <span slot="platformName" slot-scope="platformName">{{platformName ? platformName : "-"}}</span>
                    <span slot="none" slot-scope="detail">{{detail || '-'}}</span>
                    <span slot="type" slot-scope="type">{{['总计','期限卡','次卡','套餐票','课程','小商品','餐品','储值'][type]}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a v-if="getBtnByAuth('updateAmount')" class="text-primary" @click="addBound(row)">修改订单金额</a>
                        <span v-else class="text-disabled">修改订单金额</span>
                    </span>
                </a-table>
            </div>
            <!-- 扫码枪 -->
            <div v-show="type == 11">
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columnsScanner"
                    :scroll="{ x: 1200, y: 440 }"
                    :pagination="pagination"
                    :rowKey="(record,index) => index"
                    style="word-break:break-all;"
                    :loading="tableLoading"
                    @change="changePage"
                >
                    <span slot="happenTime" slot-scope="happenTime">{{happenTime ? happenTime.replace('T',' ') : "-"}}</span>
                    <span slot="platformName" slot-scope="platformName">{{platformName ? platformName : "-"}}</span>
                    <span slot="none" slot-scope="detail">{{detail || '-'}}</span>
                    <span slot="isManualPayment" slot-scope="a, row">{{row.isManualPayment ? '是' : "否"}}</span>
                    <span slot="type" slot-scope="type">{{['总计','期限卡','次卡','套餐票','课程','小商品','餐品','储值'][type]}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a v-if="getBtnByAuth('updateAmount')" class="text-primary" @click="addBound(row)">修改订单金额</a>
                        <span v-else class="text-disabled">修改订单金额</span>
                    </span>
                </a-table>
            </div>
            <div v-if="type == -1" class="mt16 text-fail">
                扣去退款金额应收： {{shouldAmountNotRefund}} 元；包含退款金额应收：{{shouldAmount}} 元
            </div>
        </div>
        <a-modal title="修改订单金额" v-model="addBoundVisible" @ok="addBoundSave">
            <div>
                修改订单金额为：<a-input-number
                        v-model="afterAmount"
                        :min="0"
                        :precision="2"
                        placeholder="请输入"
                        style="width:350px"
                    />
            </div>
            <div class="mt16">
                备注：<a-textarea v-model="remark" :rows="3" style="width:420px;vertical-align:top"/>
            </div>
        </a-modal>
    </content-view>
</template>
<script type="text/javascript">
        import { mapGetters } from 'vuex';
        const columns = [
        {
            title: '交易订单号',
            dataIndex: 'transNo',
            width: 190
        },
        {
            title: '应收金额/元',
            dataIndex: 'moneyShould',
            width: 100
        },
        {
            title: '折后金额/元',
            dataIndex: 'moneyDiscountShould',
            width: 100
        },
        {
            title: '实付金额/元',
            dataIndex: 'moneyActual',
            width: 100
        },
        {
            title: '优惠券使用',
            dataIndex: 'couponName',
            width: 100,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '收银台优惠使用',
            dataIndex: 'discountName',
            width: 140,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '支付时间',
            dataIndex: 'happenTime',
            width: 180,
            scopedSlots: { customRender: 'happenTime' }
        },
        {
            title: '支付手机号',
            dataIndex: 'account',
            width: 130
        },
        {
            title: '操作人',
            dataIndex: 'cashier',
            width: 100,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '操作票台',
            dataIndex: 'platformName',
            width: 90,
            scopedSlots: { customRender: 'platformName' }
        },
        // {
        //     title: '操作',
        //     dataIndex: 'action',
        //     width: 100,
        //     scopedSlots: { customRender: 'action' }
        // }
        ];
        const columnsScanner = [
        {
            title: '交易订单号',
            dataIndex: 'transNo',
            width: 190
        },
        {
            title: '应收金额/元',
            dataIndex: 'moneyShould',
            width: 120
        },
        {
            title: '折后金额/元',
            dataIndex: 'moneyDiscountShould',
            width: 120
        },
        {
            title: '实付金额/元',
            dataIndex: 'moneyActual',
            width: 120
        },
        {
            title: '优惠券使用',
            dataIndex: 'couponName',
            width: 120,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '收银台优惠使用',
            dataIndex: 'discountName',
            width: 140,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '支付时间',
            dataIndex: 'happenTime',
            width: 180,
            scopedSlots: { customRender: 'happenTime' }
        },
        {
            title: '支付手机号',
            dataIndex: 'account',
            width: 130
        },
        {
            title: '操作人',
            dataIndex: 'cashier',
            width: 100,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '是否手工确认',
            dataIndex: 'isManualPayment',
            width: 120,
            scopedSlots: { customRender: 'isManualPayment' }
        },
        {
            title: '操作票台',
            dataIndex: 'platformName',
            width: 90,
            scopedSlots: { customRender: 'platformName' }
        },
        ];
        const refundColumns = [
        {
            title: '交易订单号',
            dataIndex: 'transNo',
            width: 190
        },
        {
            title: '是否人工确认',
            dataIndex: "isManualPayment",
            scopedSlots: { customRender: "isManualPayment" },
            width: 120
        },
        {
            title: '支付方式',
            dataIndex: "payMode",
            scopedSlots: { customRender: "payMode" },
            width: 90
        },
        {
            title: '实收金额/元',
            dataIndex: 'actualAmount',
            width: 110
        },
        {
            title: '支付时间',
            dataIndex: 'payTime',
            width: 180
        },
        {
            title: '支付手机号',
            dataIndex: 'payPhone',
            width: 130
        },
        {
            title: '优惠券使用',
            dataIndex: 'couponName',
            width: 110,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '收银台优惠使用',
            dataIndex: 'discountName',
            width: 140,
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '退款金额/元',
            dataIndex: 'refundAmount',
            width: 110
        },
        {
            title: '退款通过时间',
            dataIndex: 'acceptRefundTime',
            width: 180
        },
        {
            title: '退款发起人/通过人',
            width: 150,
            dataIndex: 'refundInitiator',
            scopedSlots: { customRender: 'none' }
        },
        {
            title: '退款状态',
            dataIndex: 'refundStr',
            scopedSlots: { customRender: "refundState" },
            width: 120
        },
        {
            title: '备注',
            dataIndex: 'remark',
            width: 80,
            scopedSlots: { customRender: 'none' }
        }];
        const columnsAll = [
        {
            title: '商品名称',
            width: 200,
            dataIndex: 'showName',
            scopedSlots: { customRender: "showName" }
        },
        {
            title: "票券内部标识",
            dataIndex: "ticketName",
            width: 200,
            scopedSlots: { customRender: "ticketName" }
        },
        {
            title: '当日销售数量',
            dataIndex: 'sellNum'
        },
        {
            title: '销售金额',
            dataIndex: 'sellAmount'
        },
        {
            title: '当日退款数量',
            dataIndex: 'refundNum'
        },
        {
            title: '退款金额',
            dataIndex: 'refundAmount'
        },
        {
            title: '数量小计',
            dataIndex: 'subtotalNum'
        },
        {
            title: '金额小计',
            dataIndex: 'subtotalAmount'
        }];
        const financeManualDetailColumns = [
        {
            title: '手工交账金额/元',
            dataIndex: 'amount',
            scopedSlots: { customRender: "myToFixed2" }
        },
        {
            title: "手工交账类别",
            dataIndex: "manualType",
        },
        {
            title: '备注',
            dataIndex: 'remark',
            scopedSlots: { customRender: "isEmpty" }
        },
        {
            title: '操作时间',
            dataIndex: 'modifyTime'
        },
        {
            title: '操作人',
            dataIndex: 'cashierName'
        },
        {
            title: '操作票台',
            dataIndex: 'counterName'
        },
        {
            title: '操作门店',
            dataIndex: 'shopName'
        }];
    export default {
        name: 'storageSave',
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                columnsAll,
                columnsScanner,
                refundColumns,
                financeManualDetailColumns,
                dataSourceAll: [],
                dataSourceRefund: [],
                addBoundVisible: false,
                type: 4,
                afterAmount: undefined,
                id: '',
                remark: '',
                orderId: '',
                shouldAmount: '',
                shouldAmountNotRefund: '',
                shopId: undefined,
                shopName: undefined,
                tableLoading: false,
                financeManualDetailData: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        computed: {
            // ...mapGetters(['shopId'])
        },
        methods: {
            callback1(key) {
                this.type = key
                if(key == -1) {
                    this.getListAll()
                } else if(key == 99) {
                    this.getRefundList();
                } else if(key == 999) {
                    this.financeManualDetail();
                } else {
                    this.getList()
                }
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            getList() {
                if(!Boolean(this.shopId)) {
                    return false;
                }
                this.tableLoading = true;
                this.$api.financial.detailList({
                        body: {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId,
                            cashierId: this.$route.query.cashierId,
                            date: this.$route.query.date,
                            type: this.type,
                            platformId: this.$route.query.platformId,
                            platformType: this.$route.query.platformType
                        }
                    })
                    .then(res => {
                        this.tableLoading = false;
                        this.dataSource = res.list;
                        this.pagination.total = res.total;
                    }).catch(err => {
                        this.tableLoading = false;
                    })
            },
            getListAll() {
                if(!Boolean(this.shopId)) {
                    return false;
                }
                this.tableLoading = true;
                this.$api.financial.dateTicketReport({
                        params: {
                            shopId: this.shopId,
                            date: this.$route.query.date,
                            cashierId: this.$route.query.cashierId,
                            platformId: this.$route.query.platformId,
                            platformType: this.$route.query.platformType
                        }
                    })
                    .then(res => {
                        this.tableLoading = false;
                        res.total.length > 0 && res.financeTicketReportList.push({
                            type: 0,
                            showName: "-",
                            ticketName: res.total[0],
                            sellNum: res.total[1],
                            sellAmount: res.total[2],
                            refundNum: res.total[3],
                            refundAmount: res.total[4],
                            subtotalNum: res.total[5],
                            subtotalAmount: res.total[6],
                        })
                        this.dataSourceAll = res.financeTicketReportList;
                        this.shouldAmount = res.shouldAmount;
                        this.shouldAmountNotRefund = res.shouldAmountNotRefund;
                    }).catch(err => {
                        this.tableLoading = false;
                    })
            },
            getRefundList() {
                if(!Boolean(this.shopId)) {
                    return false;
                }
                this.tableLoading = true;
                this.$api.financial
                    .refundRecord({
                        params: {
                            shopId: this.shopId,
                            date: this.$route.query.date,
                            cashierId: this.$route.query.cashierId,
                            platformId: this.$route.query.platformId,
                            platformType: this.$route.query.platformType
                        }
                    }).then(res => {
                        this.tableLoading = false;
                        let successMsg = '';
                        res.forEach(el => {
                            if((el.payMode == 11 && el.isManualPayment) || el.payMode == 3 || el.payMode == 4 || (this.$moment(el.payTime).diff('2022-12-15') < 0  && this.$moment(el.applyTime).diff('2022-12-15') > 0)) {
                                successMsg = '退款成功（走线下）';
                            }else {
                                successMsg = '退款成功（系统已退）';
                            }
                            el.refundStr = ["", "退款中", successMsg, "退款失败"][el.refundState * 1]
                            el.refundInitiator = el.refundInitiator+ '/' + el.accepter;
                        });
                        this.dataSourceRefund = res;
                    }).catch( err => {
                        this.tableLoading = false;
                    })
            },
            // 添加库存
            addBound(row) {
                this.addBoundVisible = true
                this.orderId = row.orderId
                this.id = row.id
                this.afterAmount = ''
                this.remark = ''
            },
            addBoundSave() {
                if(!this.afterAmount) {
                    this.$message.error('请输入金额')
                    return false
                }

                this.$api.financial.modifyDetail({
                    body: {
                        afterAmount: this.afterAmount,
                        id: this.id,
                        remark: this.remark,
                        orderId: this.orderId,
                    }
                }).then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                    this.addBoundVisible = false
                });
            },
            /**
             * @financeManualDetail {method} 手工交账详情
             */
            financeManualDetail() {
                this.$api.financial.financeManualDetail({
                    query: {
                        shopId: this.shopId,
                        date: this.$route.query.date,
                        cashierId: this.$route.query.cashierId
                    }
                }).then(res => {
                    this.financeManualDetailData = res;
                });
            }
        },
        created() {},
        mounted() {
            this.shopId = sessionStorage.getItem('currentShopId')
            this.shopName = this.$route.query.shopName;
            this.getList();
        }
    };
</script>
<style lang="scss">
  .trade-record {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
      &_title {
          width: 100%;
          height: 40px;
          background: #fffbe6;
          border: 1px solid #ffe58f;
          border-radius: 4px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-left: 16px;
          box-sizing: border-box;
      }
  }
  .tradeRecord_tab {
      .ant-tabs-ink-bar {
          background-color: #1890ff;
      }
      .ant-tabs-nav .ant-tabs-tab-active {
          color: #1890ff;
      }
  }
</style>
